import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/useApp';
import {
  getUserByToken,
  setTokenFromApple
} from '../../store/slices/authSlice';

const SocialAppleSignin = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { status } = useAppSelector((state) => state.auth);

  const { token } = useParams();
  useEffect(() => {
    console.log('checking token...');
    if (token) {
      console.log('found token');
      dispatch(setTokenFromApple(token));
      dispatch(getUserByToken({}));
    } else {
      console.log('no token found');
    }
  }, []);

  useEffect(() => {
    if (status === 'success') {
      navigate('/points', { replace: true });
    }
  }, [status]);

  return <>Loading...</>;
};

export default SocialAppleSignin;
